export default class Notificacao {
  constructor(
    IdEmpresa = 1,
    IdNotificacao = null,
    DataNotificacao = '1 minuto atrás',
    IdColaborador = null,
    Colaborador = 'Colaborador',
    Notificacao = 'Lorem Ipsum Dolor...',
    Status = 'A',
    IdTipoNotificacao = 1,
    IdAtividade = null,
    Atividade = 'Descrição da atividade...',
    IdOcorrencia = null
  ) {
    this.IdEmpresa = IdEmpresa;
    this.IdNotificacao = IdNotificacao;
    this.DataNotificacao = DataNotificacao;
    this.IdColaborador = IdColaborador;
    this.Colaborador = Colaborador;
    this.Notificacao = Notificacao;
    this.Status = Status;
    this.IdTipoNotificacao = IdTipoNotificacao;
    this.IdAtividade = IdAtividade;
    this.Atividade = Atividade;
    this.IdOcorrencia = IdOcorrencia;
  }
}